import xss, { getDefaultCSSWhiteList, getDefaultWhiteList } from 'xss';

const XSS_LOOSE_WHITE_LIST = {
	...Object.fromEntries(
		Object.entries(getDefaultWhiteList()).map(([tag, attrs]) => [
			tag,
			Array.from(new Set([...(attrs || []), 'style', 'class'])),
		])
	),
	a: ['target', 'href', 'title', 'rel', 'style', 'class'],
	body: ['class'],
	style: [],
};

const XSS_LOOSE_OPTIONS = {
	whiteList: XSS_LOOSE_WHITE_LIST,
	css: {
		whiteList: {
			...getDefaultCSSWhiteList(),
			'line-height': true,
			'align-items': true,
			gap: true,
		},
	},
};

type Props = {
	children?: string;
	mode?: 'strict' | 'loose';
};

export function DangerousHtml({ children, mode = 'strict' }: Props) {
	const options = mode === 'loose' ? XSS_LOOSE_OPTIONS : {};
	const sanitizedText = xss(children ?? '', options);

	return (
		<span
			className="html-injected"
			/* eslint-disable-next-line react/forbid-dom-props */
			dangerouslySetInnerHTML={{ __html: sanitizedText }}
		/>
	);
}
